// extracted by mini-css-extract-plugin
export default {"root":"interests-module___root___b5c9aee3"};